import { createApi } from '@reduxjs/toolkit/query/react'
import { staggeredBaseQueryWithBailOut } from '../libs/services'
import { unversionedApiUrl } from '../services/common'
import { AppointmentType } from '../model/appointment'

const AppointmentType_TAG = 'appointmentTypeApi'

export const appointmentTypeApi = createApi({
	reducerPath: 'appointmentTypeApi',
	tagTypes: [AppointmentType_TAG],
	baseQuery: staggeredBaseQueryWithBailOut(unversionedApiUrl),
	endpoints: builder => ({
		getAppointmentList: builder.query<AppointmentType[], string>({
			query: id => ({
				url: `/v1/practices/${id}/appointmenttypes`,
			}),
			providesTags: [AppointmentType_TAG],
			extraOptions: { maxRetries: 1 },
		}),
	}),
})

export const { useGetAppointmentListQuery } = appointmentTypeApi
